<template>
  <v-dialog
    v-model="dialog"
    content-class="my-custom-dialog"
    persistent
    height="689"
    width="350"
  >
    <v-form ref="passwordReset" @submit.prevent="resetPassword">
      <!-- <v-alert
        v-model="error.show"
        :type="alertType"
        :color="alertType"
        dismissible
        >{{ error.message }}</v-alert
      > -->
      <v-card :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown, 'password-reset-dialog-card': true }">
        <div class="password-reset-dialog-title">
          <v-icon left color="white" size="32">mdi-lock-reset</v-icon>
          <span class="password-reset-dialog-title-text">Zaboravljena lozinka</span>
        </div>
        <v-card-text class="pt-6">
          <v-row class="mb-3">
            <v-col class="pt-0 mt-0 pb-0 mb-0">
              <div class="subtitle-2 text-center">
                Unesite e-mail adresu s kojom ste se registrirali
              </div>
            </v-col>
          </v-row>
          <v-row class="mb-1">
            <v-col cols="12" class="pt-0 mt-0 pb-0 mb-0">
              <v-text-field
                label="Email"
                outlined
                dense
                autofocus
                class="password-reset-input"
                :rules="[rules.email, rules.req]"
                v-model="email"
                prepend-inner-icon="mdi-email"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pr-5 pb-6 pl-10">
          <v-spacer></v-spacer>
          <v-btn class="password-reset-cancel-btn" @click="close" elevation="0">
            <v-icon left small>mdi-close</v-icon>
            Odustani
          </v-btn>
          <v-btn
            id="success"
            class="password-reset-submit-btn ml-2"
            ref="footer"
            type="submit"
            elevation="0"
          >
            <v-icon left small>mdi-check</v-icon>
            {{ $t("$vuetify.passwordReset.resetBtn") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { functions } from '@/plugins/firebase'
import rules from '@/plugins/rules'
import defaults from '@/mixins/defaults'
export default {
  data: () => ({
    alertType: 'error',
    email: '',
    error: {
      show: false,
      message: undefined,
      code: undefined
    },
    rules: {
      req: rules.req(),
      email: rules.email()
    },
    dialog: false
  }),
  mixins: [defaults],
  methods: {
    open () {
      this.email = ''
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    resetPassword () {
      if (!this.$refs.passwordReset.validate()) return
      var passwordReset = functions.httpsCallable('PasswordReset')
      passwordReset({ email: this.email }).finally(() => {
        this.alertType = 'success'
        this.error.message = this.$t('$vuetify.messages.resetLinkSent')
        this.error.show = true
        this.dialog = false
      })
    }
  }
}
</script>
<style scoped>
/* Password Reset Dialog Card */
.password-reset-dialog-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.12) !important;
}

/* Password Reset Dialog Title */
.password-reset-dialog-title {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px !important;
  display: flex !important;
  align-items: center !important;
  position: relative;
}

.password-reset-dialog-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  pointer-events: none;
}

.password-reset-dialog-title-text {
  color: white !important;
  font-weight: 700 !important;
  font-size: 20px !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

/* Password Reset Input Fields */
.password-reset-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 8px !important;
}

.password-reset-input >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.password-reset-input:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.password-reset-input.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.password-reset-input.error--text >>> fieldset {
  border-color: #F44336 !important;
  border-width: 2px !important;
}

.password-reset-input.error--text >>> .v-input__slot {
  background: rgba(244, 67, 54, 0.05) !important;
}

.password-reset-input >>> .v-icon {
  color: rgba(57, 137, 201, 0.7) !important;
}

/* Password Reset Submit Button - Soft Success Style */
.password-reset-submit-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #4CAF50 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(76, 175, 80, 0.15) !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.password-reset-submit-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  border-color: rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px);
}

.password-reset-submit-btn .v-icon {
  color: #4CAF50 !important;
  font-size: 18px !important;
}

/* Password Reset Cancel Button - Soft Danger Style */
.password-reset-cancel-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #F44336 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(244, 67, 54, 0.15) !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 18px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.password-reset-cancel-btn:hover {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  border-color: rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px);
}

.password-reset-cancel-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}
</style>
